import api from 'api';

export const loadApplications = api('GET /api/events/fields/applications');

export const loadTriggers = api('GET /api/events/fields/triggers');

export const loadTriggerParams = api('GET /api/events/fields/params');
